import { defineMessages } from 'react-intl'

export default defineMessages({
  slogan: {
    id: 'hero.slogan',
    defaultMessage: 'Connecting the world\nthrough unforgettable experiences',
  },
})
